import { QuestionEntity, RawQuestion } from '@entities/Question/Types';

export const MapQuestionsToIndexedObject = (questions: QuestionEntity[]) => {
    return questions.reduce(
        (acc, question, index) => {
            acc[index.toString() as `${number}`] = question.parse();
            return acc;
        },
        {} as { [key: `${number}`]: RawQuestion }
    );
};
